import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class InternalTestService {
  constructor(private http: HttpClient) { }

  getTest() {
    return this.http.get(`/api/internalTest/getTest`);
  }

  getAllTests() {
    return this.http.get(`/api/internalTest/getAllTests`);
  }

  getDates(testId: string) {
    return this.http.get(`/api/internalTest/getDates`, {
      params: { id: testId },
      responseType: "json",
      observe: "response"
    });
  }

  getTestDateNameById(testId: string) {
    return this.http.get(
      `/api/internalTestAdministrations/getTestDateNameById`,
      {
        params: { type: testId },
        responseType: "json",
        observe: "response"
      }
    );
  }

  getTestNameById(Id: string) {
    return this.http.get(`/api/internalTest/getTestNameById`, {
      params: { type: Id },
      responseType: "json",
      observe: "response"
    });
  }

  postPersonTest(data) {
    return this.http.post(`/api/InternalPersonTest/createPersonTest`, data, {
      observe: "response"
    });
  }

  postTestType(data) {
    return this.http.post(`/api/internalTest/postTestType`, data, {
      observe: "response"
    });
  }

  getPersonTestByTestId(personId: string, testDateId: string) {
    return this.http.get(`/api/InternalPersonTest/getPersonTestDetails`, {
      params: {
        personId: personId,
        testDateId: testDateId
      },
      responseType: "json"
    });
  }

  addTest(test: any) {
    return this.http.post(`/api/internalTest/addTest`, test, {});
  }

  editTest(test: any) {
    return this.http.post(`/api/internalTest/editTest`, test, {});
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/internaltest.service.ts